import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class UpdateArbetsorderRestriktionStatusCommand extends BasicCommand<UpdateArbetsorderRestriktionStatusCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId,
            typ: this.typ
        };
    }
    arbetsorderId: number;
    typ: string;
    status: string;
    static readonly $type = "UpdateArbetsorderRestriktionStatusCommand";

    constructor(init: (instance: UpdateArbetsorderRestriktionStatusCommand) => void) {
        super("UpdateArbetsorderRestriktionStatusCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
